<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on"
            outlined
            dense
            class="btn-edurent"
            color="primary"
            height="45"
      >
          <v-icon left dense>mdi-plus</v-icon>
          Add Roommate
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline mx-auto">Add Roommate</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined dense append-icon="mdi-magnify" v-model="search" placeholder="Search All Roommates" background-color="white"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card outlined>
              <v-list max-height="290px" min-height="290px" class="overflow-y-auto">
                <v-list-item
                  v-for="roommate in roommates"
                  :key="roommate.id"
                  v-show="roommateMatchesSearch(roommate)"
                  @mouseenter.stop="setActiveOnHover(roommate.id)"
                  @mouseleave="setActiveOnHover(null)"
                  @click="sendRoommateRequest(roommate)"
                  :class="{ active: roommate.id === activeTabIndex }"
                >
                  <v-list-item-avatar>
                    <v-img :src="roommate.image_url !== null ? roommate.image_url: 'https://place-hold.it/140/E5E5E5/FFFFFF?text=Image'"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ roommate.name }}, {{ roommate.date_of_birth | age }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <NewRoommateDialog />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import UserService from '../services/user.service'
import NewRoommateDialog from '../components/NewRoommateDialog'

export default {
  name: 'AddRoommateDialog',

  components: {
    NewRoommateDialog
  },

  data() {
    return {
      dialog: false,
      search: '',
      activeTabIndex: null,
      addingRoommate: false,
      roommateRequests: []
    }
  },

  computed: {
    roommates() {
      return this.$store.getters.getRoommates.filter(
        roommate => !this.userRoommateIds.includes(roommate.id)
      )
    },
    userRoommateIds() {
      return this.$store.getters.getUserRoommates.map(
        roommate => roommate.id
      )
    },
    user() {
      return this.$store.getters.getUser
    }
  },

  methods: {
    roommateMatchesSearch(roommate) {
      const roommateNameNormalized = roommate.name.toLowerCase()
      const searchNormalized = this.search.toLowerCase()

      return roommateNameNormalized.indexOf(searchNormalized) !== -1
    },
    setActiveOnHover(index) {
      this.activeTabIndex = index;
    },
    async sendRoommateRequest(roommate) {
      if (this.addingRoommate) {
        return
      }

      let hasErrors = false
      this.addingRoommate = true
      await UserService.sendRoommateRequest(this.user.id, { roommateId: roommate.id })
        .catch(() => {
          hasErrors = true
        })
      this.addingRoommate = false
      if (hasErrors) {
        return
      }

      await this.$nextTick()
      this.dialog = false
      this.$store.dispatch('getUserRoommates')
      this.$store.dispatch('getRoommateRequests');
    }
  },

  filters: {
    age: function(value) {
      if (value) {
        return moment().diff(String(value), 'years', false)
      }
    }
  },

  async beforeMount() {
    this.$store.dispatch('getRoommates')
    this.$store.dispatch('getUserRoommates')
  }
}
</script>

<style scoped>
.v-list-item.active {
  background-color: lightgray;
}
</style>
